import { registerComponent } from '@gig/magic-common';
import SgaBarComponent from './sga-bar.vue.js';

var SgaBar = registerComponent(SgaBarComponent);

export { SgaBar };
